import config from 'config'
import { useState } from 'react'
import { useIntl } from 'react-intl'
import FloatingActionBtnMenu from 'ui/components/FloatingActionBtn/FloatingActionBtnMenu'
import MeterWithReadingsDialog from './MeterWithReadingsDialog'
import type { ApartmentSelectOptions } from '@viilu-web/shared/types/apartment'
import MetersWithReadingsFilters from './MetersWithReadingsFilters'
import type { MetersWithReadingsFilters as Filters } from './types'
import MetersWithReadingsTable from './MetersWithReadingsTable'
import styled from 'styled-components'
import useMetersWithReadings from './useMetersWithReadings'
import MeterInvoiceDialog from '../MeterInvoicing/MeterInvoiceDialog'

const HASH_METER_READINGS = config.routeHashes.meterReadings

const Container = styled.div``

type Props = {
	selectedCompanyUUID: string
	apartmentOptions: ApartmentSelectOptions[]
}

const MetersWithReadingsView = ({
	selectedCompanyUUID,
	apartmentOptions,
}: Props) => {
	const intl = useIntl()

	const hash = window.location.hash
	const queryParams = new URLSearchParams(hash.split('?')[1])
	const queryParamUUID = queryParams.get('uuid')

	const [filters, setFilters] = useState<Filters>({
		companyUUID: selectedCompanyUUID,
		apartmentUUID: null,
		type: null,
		readingMethod: null,
		startDate: null,
		endDate: null,
	})

	const { data: metersWithReadings, loading } = useMetersWithReadings(filters)

	const [createMeterInvoice, setCreateMeterInvoice] = useState(false)

	const renderFAB = () => {
		const buttons = [
			{
				key: 'meter_reading',
				secondary: true,
				iconName: 'add',
				label: intl.formatMessage({
					defaultMessage: 'Luo tasauslasku',
					description: 'Label for the create a meter invoice button.',
				}),
				action: () => setCreateMeterInvoice(true),
			},
		]

		return (
			<FloatingActionBtnMenu
				iconName="add"
				text={intl.formatMessage({
					defaultMessage: 'Ilmoita mittarilukemia',
					description: 'Label for the .',
				})}
				buttons={buttons}
			/>
		)
	}

	return (
		<Container>
			<MetersWithReadingsFilters
				filters={filters}
				setFilters={setFilters}
				apartmentOptions={apartmentOptions}
			/>
			<MetersWithReadingsTable
				metersWithReadings={metersWithReadings}
				apartmentOptions={apartmentOptions}
				loading={loading}
			/>
			{createMeterInvoice && (
				<MeterInvoiceDialog onHide={() => setCreateMeterInvoice(false)} />
			)}
			{renderFAB()}
			{queryParamUUID && (
				<MeterWithReadingsDialog
					meterUUID={queryParamUUID}
					onHideURL={`/manager/finance/meterRegistry${HASH_METER_READINGS}`}
					apartmentOptions={apartmentOptions}
				/>
			)}
		</Container>
	)
}

export default MetersWithReadingsView
